import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';
import { FeaturesService } from 'src/app/features/features.service';

import { Dominio } from 'src/app/model/dominio-operacao.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';

@Injectable({ providedIn: 'root'})
export class FeaturesResolver implements Resolve<Observable<Map<string, boolean>>> {

    constructor(private featuresService: FeaturesService) {}

    resolve(route: ActivatedRouteSnapshot
        ): Observable<Map<string, boolean>>  {

       return this.featuresService.getFeaturesAmbiente();
             
    }
}
